import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';

import { WindowService } from 'src/shared/providers/window.service';

@Component({
  templateUrl: './upgrades.page.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UpgradesPage {
  readonly windowService = inject(WindowService);
}
